var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCpuTemp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.96;}.cls-2{fill:#fff;stroke:#fff;}.cls-2,.cls-3{stroke-miterlimit:10;}.cls-3{fill:none;stroke:#000;}.cls-4{font-size:13px;font-family:Roboto-Regular, Roboto;letter-spacing:0.2em;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CPU") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CPU"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Retangulo_de_dentro",
    "data-name": "Retangulo de dentro"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73,27a2,2,0,0,1,2,2V73a2,2,0,0,1-2,2H31.45A1.45,1.45,0,0,1,30,73.55V27H73m0-1H29V73.55A2.45,2.45,0,0,0,31.45,76H73a3,3,0,0,0,3-3V29a3,3,0,0,0-3-3Z",
    transform: "translate(-3 -2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Temperatura",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,23a4,4,0,0,1,4,4V74.15l.48.29a11.49,11.49,0,0,1-6,21.31h-.45a11.49,11.49,0,0,1-5.53-21.3l.48-.29V27a4,4,0,0,1,4-4h3m0-1H22a5,5,0,0,0-5,5V73.59a12.46,12.46,0,0,0-6,11.06A12.61,12.61,0,0,0,23,96.74h.49A12.49,12.49,0,0,0,30,73.59V27a5,5,0,0,0-5-5Z",
    transform: "translate(-3 -2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,77.69V43a1,1,0,0,0-1-1H22a1,1,0,0,0-1,1V77.69a7.5,7.5,0,1,0,5,0Z",
    transform: "translate(-3 -2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "23 75.5 21 75.5 21 75.5 23 75.5 23 75.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "23 70.5 21 70.5 21 70.5 23 70.5 23 70.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "23 60.5 21 60.5 21 60.5 23 60.5 23 60.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "23 65.5 21 65.5 21 65.5 23 65.5 23 65.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "23 55.5 21 55.5 21 55.5 23 55.5 23 55.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "23 50.5 21 50.5 21 50.5 23 50.5 23 50.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "23 45.5 21 45.5 21 45.5 23 45.5 23 45.5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Retangulo_de_fora",
    "data-name": "Retangulo de fora",
    className: "cls-3",
    d: "M12.5,79V16.63a5.1,5.1,0,0,1,5.06-5.13H82.44a5.1,5.1,0,0,1,5.06,5.13V82.37a5.1,5.1,0,0,1-5.06,5.13H35",
    transform: "translate(-3 -2)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(32.45 52.42)"
  }, "CPU"), /*#__PURE__*/React.createElement("g", {
    id: "Linhas_cima",
    "data-name": "Linhas cima"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    width: 1,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    width: 1,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    width: 1,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    width: 1,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    width: 1,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    width: 1,
    height: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Linhas_baixo",
    "data-name": "Linhas baixo"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 87,
    width: 1,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 87,
    width: 1,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 87,
    width: 1,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 87,
    width: 1,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 87,
    width: 1,
    height: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Linhas_esquerda",
    "data-name": "Linhas esquerda"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 71.5,
    width: 1,
    height: 8,
    transform: "translate(-71.5 80.5) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 60.5,
    width: 1,
    height: 8,
    transform: "translate(-60.5 69.5) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 50.5,
    width: 1,
    height: 8,
    transform: "translate(-50.5 59.5) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 40.5,
    width: 1,
    height: 8,
    transform: "translate(-40.5 49.5) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 30.5,
    width: 1,
    height: 8,
    transform: "translate(-30.5 39.5) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 20.5,
    width: 1,
    height: 8,
    transform: "translate(-20.5 29.5) rotate(-90)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Linhas_direita",
    "data-name": "Linhas direita"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 71.5,
    width: 1,
    height: 8,
    transform: "translate(14.5 166.5) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 60.5,
    width: 1,
    height: 8,
    transform: "translate(25.5 155.5) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 50.5,
    width: 1,
    height: 8,
    transform: "translate(35.5 145.5) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 40.5,
    width: 1,
    height: 8,
    transform: "translate(45.5 135.5) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 30.5,
    width: 1,
    height: 8,
    transform: "translate(55.5 125.5) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 20.5,
    width: 1,
    height: 8,
    transform: "translate(65.5 115.5) rotate(-90)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpuTemp);
export default __webpack_public_path__ + "static/media/cpu-temp.94642b1bfef95e8252c26353efe431f2.svg";
export { ForwardRef as ReactComponent };